/* @flow */

import Reflux, { RefluxAction } from "reflux";
import { ShoppingList } from "../types/ShoppingList";
import { DeleteShoppingListItem } from "../types/ShoppingListItem";
import { ListDeleteFunction } from "../types/ListItemRenderData";
import { ReplaceDto } from "../types/ReplaceDto";
import { ListSetBundleDto } from "../types/ListSetBundleDto";
import { ShoppingListCategory } from "../types/ShoppingListCategory";

const ShoppingListActions = {
    loadList: Reflux.createAction("loadList") as RefluxAction<[string]>,
    editList: Reflux.createAction("editList") as RefluxAction<[ShoppingList, string, boolean, boolean]>,
    deleteList: Reflux.createAction("deleteList") as RefluxAction<[ShoppingList]>,
    lockList: Reflux.createAction("lockList") as RefluxAction<[ShoppingList]>,
    unlockList: Reflux.createAction("unlockList") as RefluxAction<[ShoppingList]>,
    setBundle: Reflux.createAction("setBundle") as RefluxAction<[ListSetBundleDto]>,
    deleteItem: Reflux.createAction("deleteItem") as ListDeleteFunction,
    deleteMultipleItems: Reflux.createAction("deleteMultipleItems") as RefluxAction<[DeleteShoppingListItem[], string]>,
    replaceItem: Reflux.createAction("replaceItem") as RefluxAction<[ReplaceDto]>,
    addItem: Reflux.createAction("addItem") as RefluxAction<[ShoppingList, string, string]>,
    getArticlesOfCategory: Reflux.createAction("getArticlesOfCategory") as RefluxAction<[ShoppingListCategory, string]>,
    toggleCustomerVisible: Reflux.createAction("toggleCustomerVisible") as RefluxAction<[ShoppingList]>,
    handleInteraction: Reflux.createAction("handleInteraction") as RefluxAction<[string]>
};

export default ShoppingListActions;

export const {
    loadList,
    editList,
    deleteList,
    lockList,
    unlockList,
    setBundle,
    deleteItem,
    deleteMultipleItems,
    replaceItem,
    addItem,
    getArticlesOfCategory,
    toggleCustomerVisible
} = ShoppingListActions;
